export default "__VITE_ASSET___Abc16tn__"